@if (layoutFacade.displayOverlay$ | async) {
<div class="notification-overlay" (keypress)="lockApp($event)" (click)="lockApp($event)">
    <h-overlay-error-message></h-overlay-error-message>
</div>
}
